<template>
  <div class="create-content-card flex">
    <div
      v-if="!item.is_draft && item.post_type === 'post'"
      class="icon-section flex"
      style="background: rgba(96, 191, 129, 0.07)"
    >
      <img src="@/assets/MainDashboard/CreateContent/PostIcon.svg" alt="" />
    </div>

    <div
      v-else-if="!item.is_draft && item.post_type === 'poll'"
      class="icon-section flex"
      style="background: #f3f7fc"
    >
      <img src="@/assets/MainDashboard/CreateContent/Poll-Icon.svg" alt="" />
    </div>

    <div
      v-else-if="!item.is_draft && item.post_type === 'krishi_clips'"
      class="icon-section flex"
      style="background: rgba(149, 96, 191, 0.07)"
    >
      <img
        style="width: 20px"
        src="@/assets/MainDashboard/CreateContent/VideoListIcon.svg"
        alt=""
      />
    </div>

    <div v-else class="icon-section flex" style="background: #f9f5f4">
      <img src="@/assets/MainDashboard/CreateContent/DraftIcon.svg" alt="" />
    </div>

    <div class="user__content">
      <p class="--font">{{ item.campaign_name }}</p>
      <small class="secondary-font"> {{ item.author.full_name }} </small>
      <small class="mx-2" style="color: #a8aaa9" v-if="item.publish_at">
        <time-ago :datetime="item.publish_at" long :refresh="60" />
      </small>
    </div>

    <div class="attached-form">
      <img
        v-if="item.form_detail"
        src="@/assets/MainDashboard/ActiveLeads/FormListDefault.svg"
        alt=""
        class="pointer"
        @click="goToActiveLeads(item.form_detail)"
      />
    </div>

    <button
      class="--green --weight view-post"
      @click="getDetails(item.id, item.post_type)"
      :class="getButtonClass(item.post_type)"
    >
      {{ item.post_type == "poll" ? "View Poll" : "View Post" }}
    </button>

    <!-- Impression ->reach -->
    <div class="figures" v-if="!item.is_draft">
      <label>
        <div class="flex">
          Impression
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                nudge-bottom="20"
                max-width="20"
                size="15"
                color="#B8B8B8"
                v-bind="attrs"
                v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span class="tooltip_text">{{ impression_tooltip_msg }}</span>
          </v-tooltip>
        </div>
      </label>
      <p class="--font">{{ item.stats.reach }}</p>
    </div>
    <!-- <div v-else></div> -->

    <!-- views ->read  -->
    <div class="figures" v-if="!item.is_draft">
      <label>
        <div class="flex">
          Views
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                nudge-bottom="20"
                max-width="20"
                size="15"
                color="#B8B8B8"
                v-bind="attrs"
                v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span v-if="item.post_type !== 'poll'">{{
              views_tooltip_msg
            }}</span>
            <span v-if="item.post_type === 'poll'">{{
              views_tooltip_poll_msg
            }}</span>
          </v-tooltip>
        </div>
      </label>
      <p class="--font">{{ item.stats.read }}</p>
    </div>

    <!-- engagement  -->
    <div class="figures" v-if="!item.is_draft">
      <label>
        <div class="flex">
          Engagement
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                nudge-bottom="20"
                max-width="20"
                size="15"
                color="#B8B8B8"
                v-bind="attrs"
                v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span>{{ engagement_tooltip_msg }}</span>
          </v-tooltip>
        </div>
      </label>
      <p class="--font">{{ item.stats.engagement.total_count }}</p>
    </div>

    <!-- enquiries  -->
    <div class="figures" v-if="!item.is_draft && item.post_type !== 'poll'">
      <label>
        <div class="flex">
          Enquiries
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                nudge-bottom="20"
                max-width="20"
                size="15"
                color="#B8B8B8"
                v-bind="attrs"
                v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span>{{ enquiries_tooltip_msg }}</span>
          </v-tooltip>
        </div>
      </label>
      <p class="--font" v-if="item.form_detail">
        {{
          item.stats.engagement.post_form_submission_count
            ? item.stats.engagement.post_form_submission_count
            : 0
        }}
      </p>
      <p class="--font" v-else>-</p>
    </div>

    <!-- participation ->poll_participation -->
    <div class="figures" v-if="!item.is_draft && item.post_type === 'poll'">
      <label>
        <div class="flex">
          Participation
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                nudge-bottom="20"
                max-width="20"
                size="15"
                color="#B8B8B8"
                v-bind="attrs"
                v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span>{{ participation_tooltip_msg }}</span>
          </v-tooltip>
        </div>
      </label>
      <p class="--font">{{ item.stats.engagement.poll_participation }}</p>
    </div>

    <!-- Conversion  -->
    <div class="figures" v-if="!item.is_draft">
      <label>
        <div class="flex">
          Conversion
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                nudge-bottom="20"
                max-width="20"
                size="15"
                color="#B8B8B8"
                v-bind="attrs"
                v-on="on"
                >mdi-alert-circle-outline</v-icon
              >
            </template>
            <span v-if="item.post_type !== 'poll'">{{
              conversion_tooltip_msg
            }}</span>
            <span v-if="item.post_type === 'poll'">{{
              conversion_tooltip_poll_msg
            }}</span>
          </v-tooltip>
        </div>
      </label>
      <p class="--font">{{ item.stats.conversion }}%</p>
    </div>

    <div class="publish-buttons-section flex" v-if="item.is_draft">
      <button
        class="--weight delete-button"
        v-ripple
        @click="
          checkActionAndAct(
            item.id,
            item.post_type,
            'delete',
            item.form_detail ? item.form_detail.form_id : null
          )
        "
      >
        Delete
      </button>
      <button
        class="--weight"
        :class="getButtonClass(item.post_type)"
        v-ripple
        @click="publishOrDeletePost(item.id, item.post_type, 'publish')"
      >
        PUBLISH
      </button>
    </div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="#D0D0D0" class="pointer ml-1" v-bind="attrs" v-on="on"
          >mdi-dots-vertical</v-icon
        >
      </template>
      <v-list>
        <v-list-item
          v-for="(i, index) in menuItems"
          :key="index"
          link
          @click="
            checkActionAndAct(
              item.id,
              item.post_type,
              i.action,
              item.form_detail ? item.form_detail.form_id : null
            )
          "
        >
          <v-list-item-title>{{ i.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import postCard from "./post-card.vue";
import pollCard from "./poll-card.vue";
import videoCard from "./video-post.vue";
import accessToken from "../../../../helpers/accessToken";
import API_URL from "../../../../helpers/apiUrls";
import { TimeAgo } from "vue2-timeago";
import { mapActions } from "vuex";
import { eventBus } from "../../../../main";
export default {
  name: "createContentCard",
  data() {
    return {
      postDialog: false,
      pollPostDialog: false,
      videoPostDialog: false,
      postId: "",
      postType: "",
      impression_tooltip_msg: "",
      views_tooltip_msg: "",
      views_tooltip_poll_msg: "",
      engagement_tooltip_msg: "",
      enquiries_tooltip_msg: "",
      participation_tooltip_msg: "",
      conversion_tooltip_msg: "",
      conversion_tooltip_poll_msg: "",
    };
  },

  computed: {
    menuItems() {
      let items = [];
      if (this.item.is_draft) {
        items = [
          {
            title: "Edit",
            action: "edit",
          },
        ];
        if (this.item.post_type != "poll") {
          items.push({
            title: this.item.form_detail ? "Remove form" : "Attach form",
            action: this.item.form_detail ? "remove_form" : "attach_form",
          });
        }
      } else {
        items = [
          {
            title: "Delete",
            action: "delete",
          },
        ];
        if (this.item.post_type != "poll") {
          items.push({
            title: this.item.form_detail ? "Remove form" : "Attach form",
            action: this.item.form_detail ? "remove_form" : "attach_form",
          });
        }

        if (this.item.post_status != "archive") {
          items.push({
            title: "Archive",
            action: "archive",
          });
        }
      }
      return items;
    },
  },

  props: {
    item: {
      type: Object,
    },
  },

  // DELETE THE POST OR PUBLISH DRAFTED POST
  publishOrDeletePost(ID, type, action) {
    console.log(type);
    const successHandler = (response) => {
      this.$emit("refresh");
      type = type[0].toUpperCase() + type.slice(1);
      if (action === "publish")
        this.showToast(`${type} has been successfully published!`);
      else this.showToast(`${type} has been successfully deleted!`);
    };

    const errorHandler = (error) => {
      this.showToast("Something went wrong!", "error", 10000);
    };

    let endPoint = "";

    if (type === "post")
      endPoint = this.$store.getters["mainStore/GET_SUPER_ADMIN"]
        ? API_URL.createContent__updateOrDelete_Admin + `${ID}/post_update`
        : API_URL.createContent__updateOrDelete + `${ID}/post_update`;
    else if (type === "poll")
      endPoint = this.$store.getters["mainStore/GET_SUPER_ADMIN"]
        ? API_URL.createContent__updateOrDelete_Admin + `${ID}/poll_update`
        : API_URL.createContent__updateOrDelete + `${ID}/poll_update`;
    else
      endPoint = this.$store.getters["mainStore/GET_SUPER_ADMIN"]
        ? API_URL.createContent__updateOrDelete_Admin +
          `${ID}/krishi_clip_update`
        : API_URL.createContent__updateOrDelete + `${ID}/krishi_clip_update`;

    const headers = {
      Authorization: `Bearer ${accessToken.getAccessToken()}`,
      "BRAND-ID": localStorage.getItem("Brand-ID"),
    };

    const data = {};
    if (action === "publish") data.is_draft = false;
    else data.is_active = false;

    this.requestPOST(endPoint, data, headers, successHandler, errorHandler);
  },
  created() {
    this.impression_tooltip_msg = process.env.VUE_APP_TOOLTIP_IMPRESSIONS_MSG;
    this.views_tooltip_msg = process.env.VUE_APP_TOOLTIP_VIEWS_MSG;
    this.views_tooltip_poll_msg = process.env.VUE_APP_TOOLTIP_VIEWS_POLL_MSG;
    this.engagement_tooltip_msg = process.env.VUE_APP_TOOLTIP_ENGAGEMENT_MSG;
    this.enquiries_tooltip_msg = process.env.VUE_APP_TOOLTIP_ENQUIRIES_MSG;
    this.participation_tooltip_msg =
      process.env.VUE_APP_TOOLTIP_PARTICIPATION_MSG;
    this.conversion_tooltip_msg = process.env.VUE_APP_TOOLTIP_CONVERSION_MSG;
    this.conversion_tooltip_poll_msg =
      process.env.VUE_APP_TOOLTIP_CONVERSION_POLL_MSG;
  },

  methods: {
    ...mapActions("createContentStore", [
      "getPostDetails",
      "getPollDetails",
      "getVideoDetails",
    ]),
    // GET THE COLOR OF BUTTONS ACCORDING TO POST TYPE
    getButtonClass(postType) {
      if (postType === "post") return "green-button";
      else if (postType === "poll") return "blue-button";
      else return "violet-button";
    },

    // GET THE DETAILS ACCORDING TO THE TYPE AND OPEN THE RESPECTIVE MODAL
    getDetails(ID, type, from = null) {
      this.toggleLoader(true);
      const data = {
        postType: type,
        postID: ID,
        from: from,
      };
      if (type === "post") this.getPostDetails(data);
      else if (type === "poll") this.getPollDetails(data);
      else this.getVideoDetails(data);
    },

    // DELETE THE POST OR PUBLISH DRAFTED POST
    publishOrDeletePost(ID, type, action) {
      console.log(type);
      const successHandler = (response) => {
        this.$emit("refresh");
        type = type[0].toUpperCase() + type.slice(1);
        if (action === "publish")
          this.showToast(`${type} has been successfully published!`);
        else this.showToast(`${type} has been successfully deleted!`);
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong!", "error", 10000);
      };

      let endPoint = "";

      if (type === "post")
        endPoint = API_URL.createContent__updateOrDelete + `${ID}/post_update`;
      else if (type === "poll")
        endPoint = API_URL.createContent__updateOrDelete + `${ID}/poll_update`;
      else
        endPoint =
          API_URL.createContent__updateOrDelete + `${ID}/krishi_clip_update`;

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
        "BRAND-ID": localStorage.getItem("Brand-ID"),
      };

      const data = {};
      if (action === "publish") data.is_draft = false;
      else data.is_active = false;

      this.requestPOST(endPoint, data, headers, successHandler, errorHandler);
    },

    detachFormFromPost(ID, type, formID) {
      const successHandler = (response) => {
        if (response.status === 201) {
          this.$emit("refresh");
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
      };

      const data = {
        form: formID,
        post_id: ID,
        post_type: type,
        is_active: false,
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
        "BRAND-ID": localStorage.getItem("Brand-ID"),
      };

      this.requestPOST(
        API_URL.createContent__detachForm,
        data,
        headers,
        successHandler,
        errorHandler
      );
    },

    checkActionAndAct(ID, type, action, formID = null) {
      switch (action) {
        case "delete":
          const data = {
            content: "Are you sure you want to delete this post ?",
            action: () => this.publishOrDeletePost(ID, type, action),
          };
          this.$store.commit("mainStore/SET_CONFIRMATION_DIALOG", data);
          break;

        case "edit":
          this.$emit("getDetails", {
            id: ID,
            type: type,
            action: action,
          });
          break;

        case "attach_form":
          this.$store.state.createContentStore.selectedForm.postID = ID;
          eventBus.$emit("openFormList", ID);
          break;

        case "remove_form":
          this.detachFormFromPost(ID, type, formID);
          break;

        case "archive":
          const archiveData = {
            content: "Are you sure you want to archive this post ?",
            action: () => this.archiveContent(ID, type),
          };
          this.$store.commit("mainStore/SET_CONFIRMATION_DIALOG", archiveData);
          break;

        default:
          break;
      }
    },

    archiveContent(ID, type) {
      const successHandler = (response) => {
        if (response.status === 201) {
          this.$emit("refresh");
          this.showToast(`${type} has been successfully archived!`);
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
      };

      const data = {
        post_status: "archive",
        is_active: false,
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
        "BRAND-ID": localStorage.getItem("Brand-ID"),
      };

      let url = "";

      if (type == "post")
        url = `${API_URL.createContent__updateOrDelete}${ID}/post_update`;
      else if (type == "poll")
        url = `${API_URL.createContent__updateOrDelete}${ID}/poll_update`;
      else
        url = `${API_URL.createContent__updateOrDelete}${ID}/krishi_clip_update`;

      this.requestPOST(url, data, headers, successHandler, errorHandler);
    },

    goToActiveLeads(formInfo) {
      const url = this.$router.resolve({
        name: "activeLeads",
        query: { formID: formInfo.form_id },
      });
      window.open(url.href);
    },
  },

  components: {
    "post-card": postCard,
    "time-ago": TimeAgo,
    "poll-card": pollCard,
    "video-card": videoCard,
  },
};
</script>

<style lang="scss" scoped>
.create-content-card {
  background-color: white;
  box-shadow: 1px 1px 1px rgba(17, 58, 34, 0.07);
  border-radius: 5px;
  justify-content: space-between;
  padding: 15px 10px;
  margin: 5px 0 5px 0;

  p {
    margin: 0;
  }
}

.create-content-card > div {
  width: 11.5%;
}

.attached-form {
  width: 5% !important;
}

.icon-section {
  width: 50px !important;
  height: 50px;
  border-radius: 5px;
}

.icon-section img {
  width: 22px;
}

.user__content {
  margin-left: 6px;
  width: 20% !important;
}

.v-tooltip__content {
  background-color: #fff;
  color: #445149;
  // background: #D8D8D8;
  border: 0.6px solid #979797;
  border-radius: 5px;
  max-width: 250px;
  min-width: 200px;
  text-align: center;
  font-size: 13px;
  padding: 10px 12px;
}

.user__content p,
button,
.figures p {
  font-size: 0.9rem;
}
.figures .flex {
  justify-content: flex-start;
  column-gap: 2px;
}
.figures .v-icon {
  transform: rotate(5deg);
}
.view-post {
  background: #fbfdfc;
  border-radius: 5px;
  padding: 10px 15px;
}

label {
  color: #a6aca9;
  font-size: 0.8rem;
}

.publish-buttons-section {
  width: 60% !important;
  justify-content: flex-end;
}

.publish-buttons-section button {
  border-radius: 5px;
  margin-left: 8px;
  padding: 15px 30px;
}

.delete-button {
  background: #fcfcfc;
  color: #b5b5b5;
}

.green-button {
  background: #fbfdfc;
  color: var(--primary-color) !important;
}

.blue-button {
  background: #f3f7fc;
  color: #3c88c9;
}

.violet-button {
  background: rgba(149, 96, 191, 0.07);
  color: #9a5acb;
}
@media all and (min-width: 1600px) {
  .publish-buttons-section {
    width: 49% !important;
  }
}

@media all and (min-width: 1400px) {
  .create-content-card {
    padding: 15px 20px 15px 0;
  }

  .icon-section {
    transform: translateX(20px);
    width: 65px !important;
    height: 65px !important;
  }

  .figures p {
    font-size: 1rem;
  }

  label {
    font-size: 0.85rem;
  }

  .user__content {
    margin-left: 0.8rem;
    width: 20% !important;
  }

  .view-post {
    padding: 10px 20px;
  }

  .figures {
    width: 8% !important;
  }

  .publish-buttons-section {
    width: 46.4% !important;
    // width: 41.6% !important;
  }
}
@media all and (min-width: 1600px) {
  .publish-buttons-section {
    width: 49% !important;
  }
}
</style>
